import { SupplierProductListView } from "domains/supplier/components/SupplierProductListView";

export const SupplierPortalPage: React.FC = () => {
  return <SupplierProductListView />;
};
